import http from "../utils/axiosInstance";

class taskDataService {
  getAll() {
    return http.get(`/task`);
  }
  compliteTask(setId: String, taskId: string) {
    return http.post(`set/${setId}/${taskId}`);
  }
  assignTask(userId: string, data: any) {
    return http.post(`/set/${userId}`, data);
  }
  getAssignedTask(userId: string, setId: string) {
    return http.get(`/set/${userId}/${setId}`);
  }
  getUsersAssignedSet(userId: string) {
    return http.get(`/set/${userId}`);
  }
  getCompletedSet() {
    return http.get(`/set`);
  }
  handleUnFreezeUser(
    userId: string,
    freezingSetId: string,
    freezingTaskId: string
  ) {
    return http.post(
      `users/approve/${userId}/${freezingSetId}/${freezingTaskId}`
    );
  }
  deleteTask(setId: string) {
    return http.delete(`set/${setId}`);
  }
}

const taskServices = new taskDataService();
export default taskServices;
